module.exports = __webpack_public_path__ + "img/bottom-image2.633e708d.jpg";